import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-category-hero',
  templateUrl: './category-hero.component.html',
  styleUrls: ['./category-hero.component.scss']
})
export class CategoryHeroComponent {
  @Input() titleZh = '';
  @Input() titleEn = '';
  @Input() tagline = '';
  @Input() description = '';
  @Input() breadcrumbLabel = '';
  @Input() bannerImage = '';
}
